import { HttpResponse, http } from "msw";
import { apiPaths } from "../../api-paths.js";

export const abTestingHandlers = {
  postSessionVariants: [
    http.post(`**${apiPaths.abTesting.postSessionVariants}`, () => {
      return HttpResponse.json({}, { status: 200 });
    }),
  ],
  postSessionVariantsError: [
    http.post(`**${apiPaths.abTesting.postSessionVariants}`, () => {
      return HttpResponse.error();
    }),
  ],
};
